module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "pedido"
    }
  }, [_c('div', {
    attrs: {
      "id": 'titlePedido' + _vm.index
    }
  }, [_c('label', [_vm._v("Pedido " + _vm._s(_vm.linha.id) + " - " + _vm._s(_vm._f("trataData")(_vm.linha.data_hora_conclusao)))]), _c('br'), _vm._v(" "), _vm._v("\r\n        " + _vm._s(_vm.linha.cliente.nome.toUpperCase()) + " "), _c('br'), _vm._v("\r\n        " + _vm._s(_vm.linha.cliente.contato)), _c('br')]), _vm._v(" "), _c('div', {
    attrs: {
      "id": 'bodyPedido' + _vm.index
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive",
    attrs: {
      "id": 'itensNovo' + _vm.index
    }
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.linha.itensPedido), function(item) {
    return _c('div', {
      staticClass: "even"
    }, [_vm._v("\r\n                        " + _vm._s(item.qtde) + " - R$ " + _vm._s(item.total.toFixed(2)) + " - " + _vm._s(item.nome) + " " + _vm._s(item.descricao && item.descricao.length < 50 ? ("(" + (item.descricao) + ")") : '')), _c('br'), _vm._v(" "), _vm._l((item.adicionais), function(adc) {
      return (item.adicionais) ? _c('div', {
        staticClass: "adicionais"
      }, [_vm._v("\r\n                            + " + _vm._s(adc.qtde) + " - " + _vm._s(adc.produtos.nome) + "\r\n                        ")]) : _vm._e()
    }), _vm._v(" "), _c('br'), _vm._v("-------------------------------------------\r\n                    ")], 2)
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 table-responsive",
    staticStyle: {
      "margin-top": "2%"
    },
    attrs: {
      "id": 'pagamentoNovo' + _vm.index
    }
  }, [_vm._l((_vm.colunas_pagamento), function(coluna) {
    return _c('div', [_vm._v("\r\n                        " + _vm._s(coluna) + "\r\n                    ")])
  }), _vm._v(" "), _vm._l((_vm.linha.formaPagamento), function(p) {
    return _c('div', [_c('label', [_vm._v(_vm._s(p.pagamento.nome))]), _vm._v(" "), (p.pagamento.nome !== 'dinheiro') ? _c('label', [_vm._v(_vm._s(p.observacao))]) : _c('label', [_vm._v("Troco: R$" + _vm._s((parseInt(p.observacao) - _vm.linha.preco_total).toFixed(2)) + " (Troco para R$" + _vm._s(p.observacao) + ")")])])
  }), _vm._v("\r\n                -------------------------------------------\r\n                "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.linha.desconto && _vm.linha.desconto > 0),
      expression: "linha.desconto && linha.desconto > 0"
    }]
  }, [_vm._v("\r\n                 Desconto: " + _vm._s(_vm.linha.desconto) + "%\r\n                -------------------------------------------\r\n                ")]), _vm._v(" "), _c('br'), _c('label', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("Total do Pedido: " + _vm._s(_vm.linha.preco_total.toFixed(2)))])], 2), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 endereco",
    staticStyle: {
      "margin-top": "3%"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "endereco-body",
    attrs: {
      "id": 'enderecoNovo' + _vm.index
    }
  }, [(_vm.linha.enderecosPedidos && _vm.linha.enderecosPedidos.length > 0) ? _c('div', [_c('label', {
    staticClass: "lblEnd"
  }, [_vm._v("Rua: " + _vm._s(_vm.linha.enderecosPedidos[0].enderecos.rua))]), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "lblEnd"
  }, [_vm._v("Numero: " + _vm._s(_vm.linha.enderecosPedidos[0].enderecos.numero))]), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "lblEnd"
  }, [_vm._v("Bairro: " + _vm._s(_vm.linha.enderecosPedidos[0].enderecos.bairro))]), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "lblEnd"
  }, [_vm._v("Complemento: " + _vm._s(_vm.linha.enderecosPedidos[0].enderecos.complemento))])]) : (_vm.linha.cliente.enderecoCliente && _vm.linha.cliente.enderecoCliente.length > 0) ? _c('div', [_c('label', {
    staticClass: "lblEnd"
  }, [_vm._v("Rua: " + _vm._s(_vm.linha.cliente.enderecoCliente[0].rua))]), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "lblEnd"
  }, [_vm._v("Numero: " + _vm._s(_vm.linha.cliente.enderecoCliente[0].numero))]), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "lblEnd"
  }, [_vm._v("Bairro: " + _vm._s(_vm.linha.cliente.enderecoCliente[0].bairro))]), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "lblEnd"
  }, [_vm._v("Complemento: " + _vm._s(_vm.linha.cliente.enderecoCliente[0].complemento))])]) : _c('div', [_c('label', {
    staticClass: "lblEnd"
  }, [_vm._v("Irá Retirar")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('label', [_vm._v("ITENS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "endereco-title"
  }, [_c('label', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("Endereço de Entrega")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4156507e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/ModalNovoPedido.vue
// module id = 1234
// module chunks = 1